/**
 * アニメーションPNG アニメーションロジック
 *
 * .ist-js__100thAnimationPngItem にあるアニメーションPNGは、上から下にスクロールし、
 * 画像の bottom が scrollTop + innerHeight（＝viewportの下端）に入ったらアニメーションを実行します。
 * 下方向スクロールで発火し、条件を満たさなくなったタイミングでは active クラスのみ解除します。
 * 発火時は .ist-js__100thAnimationPngItem--active クラスを付与します。
 */
export class AnimationPngManager {
  private animationItems: NodeListOf<HTMLElement>;
  private prevScrollY: number = window.scrollY;

  constructor() {
    this.animationItems = document.querySelectorAll(
      '.ist-js__100thAnimationPngItem'
    );
    // 初期表示時の状態更新
    this.update();
    // スクロール・リサイズイベントに対応
    window.addEventListener('scroll', this.update.bind(this));
    window.addEventListener('resize', this.update.bind(this));
  }

  private update(): void {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > this.prevScrollY;

    this.animationItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      // 画像の bottom がビューポート内にあるかどうかで判定
      const isBottomVisible = rect.bottom <= window.innerHeight;

      // 既に active 状態の場合、条件を満たさなくなったら active クラスのみ解除
      if (
        item.classList.contains('ist-js__100thAnimationPngItem--active') &&
        !isBottomVisible
      ) {
        item.classList.remove('ist-js__100thAnimationPngItem--active');
        return;
      }

      // active 状態でなく、下方向スクロール中かつ画像の bottom がビューポート内に入っているなら APNG アニメーションを発火
      if (
        !item.classList.contains('ist-js__100thAnimationPngItem--active') &&
        isScrollingDown &&
        isBottomVisible
      ) {
        let img: HTMLImageElement | null =
          item instanceof HTMLImageElement ? item : item.querySelector('img');
        if (img) {
          const originalSrc = img.src.split('?')[0];
          // src をリセットし、強制 reflow 後にタイムスタンプ付きの新しい src を設定
          img.src = '';
          void img.offsetWidth; // 強制 reflow
          img.src = `${originalSrc}?t=${new Date().getTime()}`;
        }
        item.classList.add('ist-js__100thAnimationPngItem--active');
      }
    });

    this.prevScrollY = currentScrollY;
  }
}
